import { createFileRoute } from '@tanstack/react-router';
import { buscaDaAuditoria } from '@/features/auditoria/busca';
import { Auditoria } from '@/features/auditoria/componentes/Auditoria';
import { rotaDeTela } from '@/features/permissoes/guardas';

/** Auditoria da academia (spec 016): só owner e admin (`auditoria:read`, CA-03). */
export const Route = createFileRoute('/_autenticado/auditoria/')({
  ...rotaDeTela('auditoria.lista'),
  validateSearch: buscaDaAuditoria,
  component: Pagina,
});

function Pagina() {
  const valores = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Auditoria
      escopo="empresa"
      busca={valores}
      aoMudarBusca={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
